// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StopPlace } from './StopPlace';
import {
    StopPlaceFromJSON,
    StopPlaceFromJSONTyped,
    StopPlaceToJSON,
    StopPlaceToJSONTyped,
} from './StopPlace';
import type { StopCall } from './StopCall';
import {
    StopCallFromJSON,
    StopCallFromJSONTyped,
    StopCallToJSON,
    StopCallToJSONTyped,
} from './StopCall';
import type { AccessibilityBoardingAlighting } from './AccessibilityBoardingAlighting';
import {
    AccessibilityBoardingAlightingFromJSON,
    AccessibilityBoardingAlightingFromJSONTyped,
    AccessibilityBoardingAlightingToJSON,
    AccessibilityBoardingAlightingToJSONTyped,
} from './AccessibilityBoardingAlighting';

/**
 * Passenger relevant stop-point on a `ServiceJourney`. Some properties may further by distinguished on either `arrival` and/or `departure StopCall` aspects.
 * @export
 * @interface ScheduledStopPoint
 */
export interface ScheduledStopPoint {
    /**
     * 
     * @type {StopPlace}
     * @memberof ScheduledStopPoint
     */
    place: StopPlace;
    /**
     * Boarding (de:einsteigen) at a StopPlace on a PTRide;. Relates to **`departure`**, `stopStatus` and `accessibilityBoardingAlighting`, see [Routing-Basics](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/business/RoutingBasics.md).
     * @type {boolean}
     * @memberof ScheduledStopPoint
     */
    forBoarding: boolean;
    /**
     * Alighting (de:aussteigen) at a StopPlace on a PTRide. Relates to **`arrival`**, `stopStatus` and `accessibilityBoardingAlighting`, see [Routing-Basics](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/business/RoutingBasics.md).
     * @type {boolean}
     * @memberof ScheduledStopPoint
     */
    forAlighting: boolean;
    /**
     * Speakable description about related `forBoarding` and `forAlighting`, if any.
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    forBoardingAndAlightingFormatted?: string;
    /**
     * 
     * @type {AccessibilityBoardingAlighting}
     * @memberof ScheduledStopPoint
     */
    accessibilityBoardingAlighting?: AccessibilityBoardingAlighting;
    /**
     * Status at ScheduledStopPlace on a PTRide.This is is useful when iterating from stop to stop getting appropriate state symbols (de:Perlenschnur), see [Routing-Basics](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/business/RoutingBasics.md).<br>x-extensible-enum: [PLANNED,CANCELLED,BEGIN_PARTIAL_CANCELLATION,END_PARTIAL_CANCELLATION,NOT_SERVICED,UNPLANNED]
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    stopStatus?: string;
    /**
     * Speakable description about related `stopStatus` enum, if any.
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    stopStatusFormatted?: string;
    /**
     * Passenger needs to call for a vehicle stop (aka OJP `RequestStop`, resp. de:Halt auf Verlangen).
     * @type {boolean}
     * @memberof ScheduledStopPoint
     */
    requestStop: boolean;
    /**
     * Extended info to `stopStatus`.
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    stopUse: string;
    /**
     * 
     * @type {StopCall}
     * @memberof ScheduledStopPoint
     */
    arrival?: StopCall;
    /**
     * 
     * @type {StopCall}
     * @memberof ScheduledStopPoint
     */
    departure?: StopCall;
    /**
     * true: After a very long delay at either `arrival` or `departure` (also see related `StopCall::delayText`), according to SBB business rules. Typically blocks the whole journey or at least the ending part of a journey (like locomotive break at 3rd stop until the very last stop).
     * @type {boolean}
     * @memberof ScheduledStopPoint
     */
    delayUndefined: boolean;
    /**
     * Route index on this `ServiceJourney` (aka OJP order). Usually starting from 0 or 1 and incrementing by 1. However if the route index value jumps:
     *  - it is most likely that the journey was rerouted
     *  - or being a virtual Stop
     * @type {number}
     * @memberof ScheduledStopPoint
     */
    routeIndex?: number;
    /**
     * Occupancy in 1st class (average) at StopPlace on a PTRideLeg.<br>x-extensible-enum: [UNKNOWN,LOW,MEDIUM,HIGH]
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    occupancyFirstClass: string;
    /**
     * Occupancy in 2nd class (average) at StopPlace on a PTRideLeg.<br>x-extensible-enum: [UNKNOWN,LOW,MEDIUM,HIGH]
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    occupancySecondClass: string;
    /**
     * Exit side at this stop in direction of journey (null if unknown or irrelevant for e.g. in a Bus or on a Bicycle). Data are available in a 'current' realtime window only (and not really guaranteed).<br>x-extensible-enum: [LEFT,RIGHT]
     * @type {string}
     * @memberof ScheduledStopPoint
     */
    exitSide?: string;
    /**
     * Rank of importance based on intermediate ScheduledStopPoint priority and distance within a (partial) ServiceJourney. SBB KI rule based on display-info to find relevant intermediate stops to present on a visual stationboard (de:Perronanzeiger).Origin and destination of departure/arrival have always rank=null. Depends on `/v3/departures` or `/v3/arrivals&includeRank=true`
     * @type {number}
     * @memberof ScheduledStopPoint
     */
    rank?: number;
}

/**
 * Check if a given object implements the ScheduledStopPoint interface.
 */
export function instanceOfScheduledStopPoint(value: object): value is ScheduledStopPoint {
    if (!('place' in value) || value['place'] === undefined) return false;
    if (!('forBoarding' in value) || value['forBoarding'] === undefined) return false;
    if (!('forAlighting' in value) || value['forAlighting'] === undefined) return false;
    if (!('requestStop' in value) || value['requestStop'] === undefined) return false;
    if (!('stopUse' in value) || value['stopUse'] === undefined) return false;
    if (!('delayUndefined' in value) || value['delayUndefined'] === undefined) return false;
    if (!('occupancyFirstClass' in value) || value['occupancyFirstClass'] === undefined) return false;
    if (!('occupancySecondClass' in value) || value['occupancySecondClass'] === undefined) return false;
    return true;
}

export function ScheduledStopPointFromJSON(json: any): ScheduledStopPoint {
    return ScheduledStopPointFromJSONTyped(json, false);
}

export function ScheduledStopPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledStopPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'place': StopPlaceFromJSON(json['place']),
        'forBoarding': json['forBoarding'],
        'forAlighting': json['forAlighting'],
        'forBoardingAndAlightingFormatted': json['forBoardingAndAlightingFormatted'] == null ? undefined : json['forBoardingAndAlightingFormatted'],
        'accessibilityBoardingAlighting': json['accessibilityBoardingAlighting'] == null ? undefined : AccessibilityBoardingAlightingFromJSON(json['accessibilityBoardingAlighting']),
        'stopStatus': json['stopStatus'] == null ? undefined : json['stopStatus'],
        'stopStatusFormatted': json['stopStatusFormatted'] == null ? undefined : json['stopStatusFormatted'],
        'requestStop': json['requestStop'],
        'stopUse': json['stopUse'],
        'arrival': json['arrival'] == null ? undefined : StopCallFromJSON(json['arrival']),
        'departure': json['departure'] == null ? undefined : StopCallFromJSON(json['departure']),
        'delayUndefined': json['delayUndefined'],
        'routeIndex': json['routeIndex'] == null ? undefined : json['routeIndex'],
        'occupancyFirstClass': json['occupancyFirstClass'],
        'occupancySecondClass': json['occupancySecondClass'],
        'exitSide': json['exitSide'] == null ? undefined : json['exitSide'],
        'rank': json['rank'] == null ? undefined : json['rank'],
    };
}

  export function ScheduledStopPointToJSON(json: any): ScheduledStopPoint {
      return ScheduledStopPointToJSONTyped(json, false);
  }

  export function ScheduledStopPointToJSONTyped(value?: ScheduledStopPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': StopPlaceToJSON(value['place']),
        'forBoarding': value['forBoarding'],
        'forAlighting': value['forAlighting'],
        'forBoardingAndAlightingFormatted': value['forBoardingAndAlightingFormatted'],
        'accessibilityBoardingAlighting': AccessibilityBoardingAlightingToJSON(value['accessibilityBoardingAlighting']),
        'stopStatus': value['stopStatus'],
        'stopStatusFormatted': value['stopStatusFormatted'],
        'requestStop': value['requestStop'],
        'stopUse': value['stopUse'],
        'arrival': StopCallToJSON(value['arrival']),
        'departure': StopCallToJSON(value['departure']),
        'delayUndefined': value['delayUndefined'],
        'routeIndex': value['routeIndex'],
        'occupancyFirstClass': value['occupancyFirstClass'],
        'occupancySecondClass': value['occupancySecondClass'],
        'exitSide': value['exitSide'],
        'rank': value['rank'],
    };
}

